import { createFluentIcon } from '@fluentui/react-icons';

export const CCircle20Regular = createFluentIcon(
    'CCircle20Regular',
    '20',
    [
        'M10 17.875a7.875 7.875 0 1 1 0-15.75 7.875 7.875 0 0 1 0 15.75Zm0 1.125a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
        'M13.409 7.318a.563.563 0 0 1-.769-.206A3.376 3.376 0 1 0 12.813 11.688a.563.563 0 0 1 1.125 0 4.503 4.503 0 1 1-.23-4.717.563.563 0 0 1-.299.347Z'
    ]
);